import { lbBrand } from '@fuse/colors';
import { AppDispatch } from 'app/store';
import { clearNavigationBadge, setNavigationBadge } from 'app/store/fuse/navigationBadgesSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { REMINDER_MARK } from './campaignReminder';
import { useCampaignReminder } from './useCampaignReminder';

// The id of the campaign entry in `navigationConfig.ts`.
const CAMPAIGN_NAV_ID = 'notification-campaign';

export const CampaignNavBadge = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isDue = Boolean(useCampaignReminder()?.isDue);

  useEffect(() => {
    if (!isDue) {
      dispatch(clearNavigationBadge(CAMPAIGN_NAV_ID));
      return;
    }
    // Icon mark only: a `title` would add a second "!" at the end of the entry when the menu is expanded.
    dispatch(
      setNavigationBadge({
        id: CAMPAIGN_NAV_ID,
        badge: {
          iconTitle: REMINDER_MARK,
          bg: lbBrand.red,
          fg: lbBrand.white,
          scope: 'franchise',
        },
      }),
    );
  }, [dispatch, isDue]);

  return null;
};
